import moment from "moment";
/**
 * Whether a cart item's booking date has already passed.
 *
 * Compared in local time. The Cart page previously used
 * `new Date(booking_date).toISOString()`, which converts to UTC: east of
 * Greenwich that shifts a midnight booking date back a day, so an item booked for
 * *today* read as expired. The Checkout step used a local moment comparison and
 * read it as valid, so its Checkout button stayed enabled while the step guard
 * silently refused to advance — a dead button with no error.
 *
 * Shared so the two cannot drift apart again. Parsed strictly against the formats
 * the backend actually serves rather than left to `new Date`, which does not
 * handle `DD-MMM-YYYY` dependably.
 */
export const BOOKING_DATE_PARSE_FORMATS = ["DD-MMM-YYYY", "YYYY-MM-DD", moment.ISO_8601];

export const isBookingDateInPast = (bookingDate?: string | null): boolean => {
    if (!bookingDate) return false;
    const parsed = moment(bookingDate, BOOKING_DATE_PARSE_FORMATS, true);
    if (!parsed.isValid()) return false;
    return parsed.format("YYYY-MM-DD") < moment().format("YYYY-MM-DD");
};

